import { render, staticRenderFns } from "./SmartMessage.vue?vue&type=template&id=54fa7ae0&scoped=true&"
import script from "./SmartMessage.vue?vue&type=script&lang=js&"
export * from "./SmartMessage.vue?vue&type=script&lang=js&"
import style0 from "./SmartMessage.vue?vue&type=style&index=0&id=54fa7ae0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fa7ae0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAvatar,VIcon,VImg,VProgressCircular})
